import {NAME} from "./constants";

const getModel = (state) => state[NAME];
export const getIsFetchingSelector = (id) => (state) => getModel(state)[id];
